export enum ErrorCode {
    ALREADY_EXISTS = 'ALREADY_EXISTS',
    ASSOCIATION_EXISTS = 'ASSOCIATION_EXISTS',
    NOT_FOUND = 'NOT_FOUND',
    BUSINESS_RULE_VIOLATED = 'BUSINESS_RULE_VIOLATED',
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
    DIFFERENT_ACCOUNT = 'DIFFERENT_ACCOUNT',
    SAME_ACCOUNT = 'SAME_ACCOUNT',
    BLOCKED_SHIPMENT = 'BLOCKED_SHIPMENT',
    NOT_YET_AUTO_RATED = 'NOT_YET_AUTO_RATED',
    RATE_SCALE_EXISTS = 'RATE_SCALE_EXISTS',
    MASTER_LINKED_SHIPMENT_VALIDATION_FAILED = 'MASTER_LINKED_SHIPMENT_VALIDATION_FAILED',
  }